// extracted by mini-css-extract-plugin
export default {"content":"style_content__vmfrO","itemName":"style_itemName__ENqd7"};